import { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react";
import cn from "classnames";
import styles from "./Button.module.scss";

interface ButtonPropsI
  extends DetailedHTMLProps<HTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  children: ReactNode;
  type?: "button" | "slide" | "submit";
  disabled?: boolean;
  left?: boolean;
}

export default function Button({
  children,
  className,
  disabled,
  type = "button",
  left = false,
  ...props
}: ButtonPropsI): JSX.Element {
  return (
    <button
      className={cn(styles.button, className, {
        [styles.disabled]: disabled,
        [styles.submit]: type === "submit",
        [styles.slide]: type === "slide",
        [styles.left]: left,
      })}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
